import { fetch, post } from "../plugin/fetch";
import { useLocal } from "../plugin/tools"
import Vue from 'vue'
import { Dialog } from 'vant'
Vue.use(Dialog);
export default {
    namespaced: true,
    state: {
        appId: null,
        verNum: null,
        LOADING: false,
        status: false,
        showa1: false,
        historyTime: 0,
        novelSection: '',
        songListId: '',
        detailId: {},
        musicId: '',
        musicName: '',
        FeedBack: {},
        HistoryList: [],
        FetchBack: null,
        Token: null,
        Share: null,
        UserData: null,
        Product: [],
        PayMethord: [],
        PromoInfo: [],
        Intro: [],
        BillPage: null,
        TaskList: [],
        TaskListTop: [],
        AreaList: [],
        Promote1: {},
        NavIgationList: [],
        NavSection: [],
        NavSection2_3: [],
        ColumnMore: [],
        ColumnMore2: [],
        Attention: {},
        HostDetail: {},
        NovelList: [],
        Promote: {},
        NovelDetail: {},
        chapterList: {},
        Anchor: {},
        PlayUrl: {},
        Playtime: {},
        Multi: [],
        Takeout: {},
        newList: [],
        topicDetail: {},
        topicList: {},
        specialId: 0,
        historyKey: '',
        musicListid: '',
        // HistoryInfo:{}
        historyData: [],
        iconFlag: false,
        Userid: null,
        navIndex: 0,
        navList: [],
    },
    getters: {
        Promotions(state) {
            let cale = {};
            state.PromoInfo.map((item) => {
                if (cale[`pos${item.position_id}`]) {
                    cale[`pos${item.position_id}`].push(item);
                } else {
                    cale[`pos${item.position_id}`] = [item];
                }
            })
            return cale;
        },
        navIndex(state) {
            return state.navIndex
        },
        navList(state) {
            return state.navList
        },
    },
    mutations: {
        showLoading(state) {
            state.LOADING = true
        },
        setIconFlag(state) {
            state.iconFlag = true
        },
        hideLoading(state) {
            state.LOADING = false
        },
        setShowa1(state, data) {
            state.showa1 = data
        },
        // setHistoryInfo(state,data){
        //     state.HistoryInfo = data
        // },
        setUserid(state, data) {
            state.Userid = data
        },
        setverNum(state, data) {
            state.verNum = data
        },
        setappId(state, data) {
            state.appId = data
        },
        setNovelSection(state, data) {
            state.novelSection = data
        },
        setMusicListid(state, data) {
            state.musicListid = data
        },
        setHistoryTime(state, data) {
            state.historyTime = data
        },
        setHistoryKey(state, data) {
            state.historyKey = data
        },
        setHistoryData(state, data) {
            state.historyData = data
        },
        setStatus(state, data) {
            state.status = data
        },
        setMusicId(state, data) {
            state.musicId = data;
        },
        setSpecialId(state, data) {
            state.specialId = data;
        },
        setTopicDetail(state, data) {
            state.topicDetail = data;
        },
        setTopicList(state, data) {
            state.topicList = data;
        },
        setMusicName(state, data) {
            state.musicName = data;
        },
        setSongListId(state, data) {
            state.songListId = data;
        },
        setDetailId(state, data) {
            state.detailId = data;
        },
        setNavIgation(state, data) {
            state.NavIgationList = data;
        },
        setNewList(state, data) {
            state.newList = data;
        },

        setNavSection(state, data) {
            state.NavSection = data;
        },
        setNavSection2_3(state, data) {
            state.NavSection2_3 = data;
        },
        setColumnMore(state, data) {
            state.ColumnMore = data;
        },
        setColumnMore2(state, data) {
            state.ColumnMore2 = data;
        },
        setAttention(state, data) {
            state.Attention = data;
        },
        setHostDetail(state, data) {
            state.HostDetail = data;
        },
        setNovelList(state, data) {
            state.NovelList = data;
        },
        // setTaskList(state,data){
        //     state.taskList = data;
        // },
        setPromote(state, data) {
            state.Promote = data;
        },
        setFeedBack(state, data) {
            state.FeedBack = data;
        },
        setHistoryList(state, data) {
            state.HistoryList = data;
        },
        setFetchBack(state, data) {
            state.FetchBack = data;
        },
        setToken(state, data) {
            state.Token = data;
            // useLocal('token', data || 'delete')
        },
        setShare(state, data) {
            state.Share = data;
        },
        setUserData(state, data) {
            state.UserData = data || null;
        },
        setProduct(state, data) {
            state.Product = data || [];
        },
        setPayMethord(state, data) {
            state.PayMethord = data || [];
        },
        setPromoInfo(state, data) {
            state.PromoInfo = data || [];
        },
        setIntro(state, data) {
            state.Intro = data || [];
        },
        setBillPage(state, data) {
            state.BillPage = data;
        },
        setTaskList(state, data) {
            state.TaskList = data;
        },
        setTaskListTop(state, data) {
            state.TaskListTop = data;
        },
        setAreaList(state, data) {
            state.AreaList = data;
        },
        setPromote1(state, data) {
            state.Promote1 = data;
        },
        setChapterList(state, data) {
            state.chapterList = data;
        },
        setNovelDetail(state, data) {
            state.NovelDetail = data
        },
        setAnchor(state, data) {
            state.Anchor = data
        },
        setPlayUrl(state, data) {
            state.PlayUrl = data
        },
        setPlaytime(state, data) {
            state.Playtime = data
        },
        setMulti(state, data) {
            state.Multi = data
        },
        setTakeout(state, data) {
            state.Takeout = data
        },
        setnNavIndex(state, data) {
            state.navIndex = data
        },
        setnNavList(state, data) {
            state.navList = data
        },
    },
    actions: {
        //反馈内容
        fetchFeedBack({ state, commit }, data) {
            return new Promise((resolve, reject) => {
                post('/api/other/feedback', data, {
                    'token': state.Token || ''
                }).then(res => {
                    if (res.code == 200) {
                        commit('setFeedBack', res.data);
                        resolve(res)
                        // alert('意见反馈成功')
                    }
                });
            });
        },
        //暂停判断次数
        fetchPause({ state, commit }, data) {
            return new Promise((resolve, reject) => {
                post('/api/pause_check', data, {
                    'token': state.Token || ''
                }).then(res => {
                    resolve(res)
                });
            });
        },
        //获取历史记录
        fetchHistoryList({ state, commit }, data) {
            return new Promise((resolve, reject) => {
                fetch('/api/novel/history', data, {
                    'token': state.Token || ''
                }).then(res => {
                    if (res.code == 200) {
                        commit('setHistoryList', res.data);
                        commit('setHistoryData', res.data);
                        resolve(res)
                    }
                })
            });
        },
        //已关注主播
        fetchAlreadyList({ state, commit }, data) {
            return new Promise((resolve, reject) => {
                fetch('/api/anchor/attention/list', data, {
                    'token': state.Token || ''
                }).then(res => {
                    if (res.code == 200) {
                        resolve(res)
                        console.log(res)
                    }
                });
            });
        },
        //删除一个历史记录
        fetchHistoryClear({ state, commit }, data) {
            return new Promise((resolve, reject) => {
                fetch('/api/novel/clear/history', data, {
                    'token': state.Token || ''
                }).then(res => {
                    if (res.code == 200) {
                        // commit('setHistoryList', res.data);
                        resolve(res)
                    }
                }); 0.
            });
        },
        //清除所有历史记录
        fetchHistorysClear({ state, commit }, data) {
            return new Promise((resolve, reject) => {
                fetch('/api/novel/clear/historys', data, {
                    'token': state.Token || ''
                }).then(res => {
                    if (res.code == 200) {
                        // commit('setHistoryList', res.data);
                        resolve(res)
                    }
                });
            });
        },
        //获取短信验证
        fetchMessageCode({ commit }, data) {
            return new Promise((resolve, reject) => {
                post('/api/send_sms', data, {
                    // mobile:data ,
                    // area : data
                }).then(res => {
                    commit('setFetchBack', res.msg);
                    resolve(res)
                })
            });
        },
        //获取短信区号列表
        fetchAreaList({ commit }, data) {
            return new Promise((resolve, reject) => {
                post('/api/sms_area', {}).then(res => {
                    commit('setAreaList', res.data.area_list);
                    resolve(res)
                })
            });
        },
        //登录
        // fecthLogin({commit},payload) {
        //     return new Promise((resolve,reject) => {
        //         post('/api/user_login', {
        //             ...payload
        //         }).then(res => {
        //             if(res.code==200){
        //                 commit('setFetchBack', res.msg);
        //                 commit('setToken', res.token);
        //             }else{
        //                 Dialog.alert({
        //                     title:'提醒',
        //                     message: res.msg
        //                 })
        //             }
        //         })
        //     });
        // },
        //获取分享链接
        fecthShare({ state, commit }, payload) {
            return new Promise((resolve, reject) => {
                fetch('/api/other/share', {}, {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'token': state.Token || ''
                }).then(res => {
                    commit('setShare', res.data && res.data.url);
                    resolve(res)
                })
            });
        },
        //获取用户信息
        fetchUserInfo({ state, commit }, payload) {
            return new Promise((resolve, reject) => {
                post('/api/user_infos', {
                    //'token': 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2luZm9zIjp7InVpZCI6NywibW9iaWxlIjoiMTMxNjA4MTE0NzUiLCJuaWNrbmFtZSI6Ilx1NmNlOFx1NTE4Y1x1NzUyOFx1NjIzNzYzMzM0OSIsImxhc3RfbG9naW5faXAiOiIxMjcuMC4wLjEiLCJsYXN0X2xvZ2luX3RpbWUiOiIyMDE5LTEyLTI3IDE3OjQ0OjU1IiwidG9kYXlfYWxyZWFkeV9saXN0ZW4iOjAsInRvZGF5X2xlZnRfbGlzdGVuIjowLCJjdXJyZW50X3ZpcF9sZXZlbCI6MCwiY3VycmVudF92aXBfbmFtZSI6IiIsImdldF9uZXh0X3ZpcF9kZXNjIjoiIiwibmV4dF92aXBfbGV2ZWwiOiIiLCJuZXh0X3ZpcF9uYW1lIjoiIn19.NrYdedysYpOWg-3r6wACK3P5BEXWZd5oHVr1agUUJhQ'
                }, {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'token': state.Token || ''
                    // 'token': 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ1c2VyX2luZm9zIjp7InVpZCI6NywibW9iaWxlIjoiMTMxNjA4MTE0NzUiLCJuaWNrbmFtZSI6Ilx1NmNlOFx1NTE4Y1x1NzUyOFx1NjIzNzYzMzM0OSIsImxhc3RfbG9naW5faXAiOiIxMjcuMC4wLjEiLCJsYXN0X2xvZ2luX3RpbWUiOiIyMDE5LTEyLTI3IDE3OjQ0OjU1IiwidG9kYXlfYWxyZWFkeV9saXN0ZW4iOjAsInRvZGF5X2xlZnRfbGlzdGVuIjowLCJjdXJyZW50X3ZpcF9sZXZlbCI6MCwiY3VycmVudF92aXBfbmFtZSI6IiIsImdldF9uZXh0X3ZpcF9kZXNjIjoiIiwibmV4dF92aXBfbGV2ZWwiOiIiLCJuZXh0X3ZpcF9uYW1lIjoiIn19.NrYdedysYpOWg-3r6wACK3P5BEXWZd5oHVr1agUUJhQ'
                }).then(res => {
                    if (res.code == 401) {
                        // commit('setToken', null);
                        // commit('setUserData', null);
                    } else {
                        resolve(res)
                        // commit('setUserData', res.data);
                    }
                    if (res.code == 504) {

                    }
                    commit('setIntro', res.data && res.data.about_us);
                    commit('setPromoInfo', res.data && res.data.ad_info);
                })
            });
        },
        //token更新
        fecthTakeout({ state, commit }, payload) {
            return new Promise((resolve, reject) => {
                post('/api/update', {}, {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'token': state.Token || ''
                }).then(res => {
                    commit('setTakeout', res.data);
                })
            });
        },
        //获取充值信息
        fecthProduct({ state, commit }, payload) {
            return new Promise((resolve, reject) => {
                fetch('/api/get_pay_products', {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'token': state.Token || ''
                }).then(res => {
                    commit('setProduct', res.data && res.data.products);
                })
            });
        },
        //获取支付方式
        fecthPayMethord({ state, commit }, payload) {
            return new Promise((resolve, reject) => {
                post('/api/pay', {}, {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'token': state.Token || ''
                }).then(res => {
                    commit('setPayMethord', res.data && res.data.pay_list);
                    resolve(res)
                })
            });
        },
        //推广任务列表
        fecthTaskList({ state, commit }, payload) {
            return new Promise((resolve, reject) => {
                fetch('/api/get_task_list', {}, {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'token': state.Token || ''
                }).then(res => {
                    commit('setTaskList', res.data && res.data.task_list);
                    commit('setTaskListTop', res.data && res.data.task_list_top);
                })
            });
        },
        //提交支付订单
        fecthBill({ state, commit }, payload) {
            return new Promise((resolve, reject) => {
                post('/api/pay_do', {
                    ...payload
                }, {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'token': state.Token || ''
                }).then(res => {
                    if (res.code == 200) {
                        commit('setBillPage', res.data && res.data.pay_link);
                    } else {
                        commit('setFetchBack', res.msg);
                    }
                })
            });
        },
        //退出登录
        fecthOutLogin({ state, commit }, payload) {
            return new Promise((resolve, reject) => {
                post('/api/login_out', {
                    ...payload
                }, {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'token': state.Token || ''
                }).then(res => {
                    if (res.code == 200) {
                        alert('已经退出登录')
                    } else {

                    }
                })
            });
        },
        //广告ID选择
        fecthAdlend({ state, commit }, payload) {
            return new Promise((resolve, reject) => {
                post('/api/get_position_ad', {
                    ...payload
                }, {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'token': state.Token || ''
                }).then(res => {
                    resolve(res)
                })
            });
        },
        //主页小说tab
        fetchPromote1({ state, commit }, data) {
            return new Promise((resolve, reject) => {
                fetch('/api/navigation/bottom', data, {
                    token: state.Token || ''
                }).then(res => {
                    if (res.code == 200) {
                        commit('setPromote1', res.data);
                        resolve(res)
                    } else {

                    }
                });
            });
        },

        //获取导航列表
        fetchNavIgation({ state, commit }, data) {
            return new Promise((resolve, reject) => {
                fetch('/api/navigation/list', data, {
                    token: state.Token || ''
                }).then(res => {
                    if (res.code == 200) {
                        commit('setNavIgation', res.data);
                        resolve(res)
                    }
                });
            });
        },
        //获取导航分类详细信息
        fetchNavSection({ state, commit }, data) {
            return new Promise((resolve, reject) => {
                fetch('/api/navigation/section', data, {
                    'token': state.Token || ''
                }).then(res => {

                    if (res.code == 200) {
                        commit('setNavSection', res.data);
                        resolve(res)
                    } else {
                        resolve(res)
                    }
                });
            });
        },
        //换一换
        fetchNavSection2({ state, commit }, data) {
            return new Promise((resolve, reject) => {
                fetch('/api/navigation/section2_3', data, {
                    'token': state.Token || ''
                }).then(res => {
                    if (res.code == 200) {
                        commit('setNavSection2_3', res.data);
                        resolve(res)
                    }
                });
            });
        },
        //获取栏目更多
        fetchColumnMore({ state, commit }, data) {
            return new Promise((resolve, reject) => {
                fetch('/api/navigation/more', data, {
                    'token': state.Token || ''
                }).then(res => {
                    if (res.code == 200) {
                        commit('setColumnMore', res.data);
                        resolve(res)
                    } else {
                        resolve(res)
                    }
                });
            });
        },
        fetchColumnMore2({ state, commit }, data) {
            return new Promise((resolve, reject) => {
                fetch('/api/last_update_story', data, {
                    'token': state.Token || ''
                }).then(res => {
                    if (res.code == 200) {
                        commit('setColumnMore2', res.data);
                        resolve(res)
                    } else {
                        resolve(res)
                    }
                });
            });
        },
        //新主播
        fetchNewHotList({ state, commit }, data) {
            return new Promise((resolve, reject) => {
                post('/api/anchor_list_new', data, {
                    'token': state.Token || ''
                }).then(res => {
                    if (res.code == 200) {
                        commit('setNewList', res.data);
                        resolve(res)
                    } else {
                        resolve(res)
                    }
                });
            });
        },
        //主播详情
        fetchHostDetail({ state, commit }, data) {
            return new Promise((resolve, reject) => {
                fetch('/api/anchor/details', data, {
                    'token': state.Token || ''
                }).then(res => {
                    if (res.code == 200) {
                        commit('setHostDetail', res.data);
                        resolve(res)
                    }
                });
            });
        },
        //获取主播作品列表
        fetchNovelList({ state, commit }, data) {
            return new Promise((resolve, reject) => {
                fetch('/api/anchor/novel/list', data, {
                    'token': state.Token || ''
                }).then(res => {
                    if (res.code == 200) {
                        commit('setNovelList', res.data);
                        resolve(res)
                    }
                });
            });
        },
        //主播关注/取消关注
        fetchAttention({ state, commit }, data) {
            return new Promise((resolve, reject) => {
                fetch('/api/anchor/attention', data, {
                    'token': state.Token || ''
                }).then(res => {
                    commit('setAttention', res.data);
                    resolve(res)
                });
            });
        },
        //专题列表
        fetchTopicList({ state, commit }, data) {
            return new Promise((resolve, reject) => {
                fetch('/api/topic/index', data, {
                    'token': state.Token || ''
                }).then(res => {
                    commit('setTopicList', res.data);
                    resolve(res)
                });
            });
        },
        //专题详情
        fetchTopic({ state, commit }, data) {
            return new Promise((resolve, reject) => {
                fetch(`/api/topic/detail/${state.specialId}`, data, {
                    'token': state.Token || ''
                }).then(res => {
                    commit('setTopicDetail', res.data);
                    resolve(res)
                });
            });
        },
        //推广信息
        fetchPromote({ state, commit }, data) {
            return new Promise((resolve, reject) => {
                post('/api/promote_list', data, {
                    'token': state.Token || ''
                }).then(res => {
                    if (res.code == 200) {
                        commit('setPromote', res.data);
                        resolve(res)
                    } else {
                        alert(res.msg)
                    }
                });
            });
        },
        //小说章节列表
        fetchChapter({ state, commit }, data) {
            return new Promise((resolve, reject) => {
                fetch('/api/novel/chapter/list', data, {
                    'token': state.Token || ''
                }).then(res => {
                    if (res.code == 200) {
                        commit('setChapterList', res.data);
                        resolve(res)
                    } else {
                        resolve(res)
                    }
                });
            });
        },
        //获取小说详情
        fetchNovelDetail({ state, commit }, data) {
            return new Promise((resolve, reject) => {
                fetch('/api/novel/details', data, {
                    'token': state.Token || ''
                }).then(res => {
                    if (res.code == 200) {
                        commit('setNovelDetail', res.data);
                        resolve(res)
                    }
                });
            });
        },
        //已关注主播
        fetchAlreadyList({ state, commit }, data) {
            return new Promise((resolve, reject) => {
                fetch('/api/anchor/attention/list', data, {
                    'token': state.Token || ''
                }).then(res => {
                    if (res.code == 200) {
                        resolve(res)
                    }
                });
            });
        },
        //检查主播是否被关注
        fetchAnchor({ state, commit }, data) {
            return new Promise((resolve, reject) => {
                fetch('/api/anchor/check', data, {
                    'token': state.Token || ''
                }).then(res => {
                    if (res.code == 200) {
                        commit('setAnchor', res.data);
                        resolve(res)
                    }
                });
            });
        },
        //获取小说章节播放连接
        fetchPlayUrl({ state, commit }, data) {
            return new Promise((resolve, reject) => {
                fetch('/api/novel/url', data, {
                    'token': state.Token || ''
                }).then(res => {
                    commit('setPlayUrl', res.data);
                    resolve(res)
                });
            });
        },
        //记录播放时长
        fetchPlaytime({ state, commit }, data) {
            return new Promise((resolve, reject) => {
                post('/api/novel/playtime', data, {
                    'token': state.Token || ''
                }).then(res => {
                    if (res.code == 200) {
                        commit('setPlaytime', res.data);
                        resolve(res)
                    }
                });
            });
        },
        //记录播放时长
        fetchExchangetask({ state, commit }, data) {
            return new Promise((resolve, reject) => {
                post('/api/exchange_task', data, {
                    'token': state.Token || ''
                }).then(res => {
                    resolve(res)
                });
            });
        },
        fetchMulti({ state, commit }, data) {
            return new Promise((resolve, reject) => {
                fetch('/api/novel/novels', data, {
                    'token': state.Token || ''
                }).then(res => {
                    if (res.code == 200) {
                        commit('setMulti', res.data);
                        resolve(res)
                    }
                });
            });
        },
        // 添加到历史记录
        fetchAddCollectAudio({ state }, data) {
            return new Promise((resolve, reject) => {
                post('/api/add_collect_audio', data, {
                    'token': state.Token || ''
                }).then(res => {
                    if (res.code == 200) {
                        // commit('setMulti', res.data);
                        resolve(res)
                    }
                });
            });
        },
        // 更新历史记录
        fetchUpdateCollectAudio({ state }, data) {
            return new Promise((resolve, reject) => {
                post('/api/update_collect_audio', data, {
                    'token': state.Token || ''
                }).then(res => {
                    if (res.code == 200) {
                        // commit('setMulti', res.data);
                        resolve(res)
                    }
                });
            });
        },
    }
}